module.exports = __webpack_public_path__ + "static/img/pc-web-img05@t.b51ce78.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/hyundai-steel/pc-web-img05@t.png
// module id = A7uE
// module chunks = 0